import {
  AssessmentQuestion,
  CategorisationTreeOption,
  CategorisationTreeQuestion,
} from '../types'
import { AnswerMap } from '../util/categorisationTree'
import { QuestionType } from '../enums'
import ZRadio from './ZRadio'
import ZTextField from './ZTextField'
import ZText from './ZText'

type AnyQuestion = CategorisationTreeQuestion | AssessmentQuestion

const TreeQuestion = ({
  question,
  answers,
  onChange,
  tag,
}: {
  question: AnyQuestion
  answers: AnswerMap
  onChange: (
    questionId: string,
    answer: { answerId?: string; answerInput?: string },
  ) => void
  tag?: string
}) => {
  if (question.type === QuestionType.InputNumeric) {
    return (
      <div>
        <ZText style={{ marginBottom: '0.5rem' }}>{question.label}</ZText>

        <ZTextField
          label="Insert value"
          format={question.inputFormat ?? undefined}
          fullWidth
          onChange={input => onChange(question.id, { answerInput: input })}
        />
      </div>
    )
  }

  if (question.type === QuestionType.InputText) {
    return (
      <div>
        <ZText style={{ marginBottom: '0.5rem' }}>{question.label}</ZText>

        <ZTextField
          label="Insert the name of the firm"
          format={question.inputFormat ?? undefined}
          fullWidth
          onChange={input => onChange(question.id, { answerInput: input })}
        />
      </div>
    )
  }

  const options = (question.options ?? []) as CategorisationTreeOption[]

  const isAnswered = answers[question.id]?.answerId != null

  const questionChildren: CategorisationTreeQuestion[] =
    'questionChildren' in question ? (question.questionChildren ?? []) : []

  return (
    <div style={{ display: 'flex', rowGap: '1rem', flexDirection: 'column' }}>
      <div>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'baseline' }}>
          {tag ? <ZText style={{ fontWeight: 700 }}>{tag}</ZText> : null}
          <ZText style={{ marginBottom: '2rem' }}>{question.label}</ZText>
        </div>

        <ZRadio
          style={{ rowGap: '1rem' }}
          options={options.map(option => ({
            value: option.id,
            label: option.label,
            subLabel: option.subLabel ?? undefined,
            checked: option.id === answers[question.id]?.answerId,
          }))}
          onChange={event =>
            onChange(question.id, { answerId: event.target.value })
          }
          renderAfterOption={optionId => {
            const isSelected = optionId === answers[question.id]?.answerId
            if (!isSelected) return null
            const nextQuestions =
              options.find(option => option.id === optionId)?.nextQuestions ??
              []
            return nextQuestions.map(next => (
              <div key={next.id} style={{ marginTop: '1rem' }}>
                <TreeQuestion
                  question={next}
                  answers={answers}
                  onChange={onChange}
                />
              </div>
            ))
          }}
        />
      </div>

      {isAnswered
        ? questionChildren.map(child => (
            <TreeQuestion
              key={child.id}
              question={child}
              answers={answers}
              onChange={onChange}
            />
          ))
        : null}
    </div>
  )
}

export default TreeQuestion
